import { genUUID } from '~/utils/generate'
import { hasWindow } from '~/utils/helpers'

const measurementId = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID
const apiSecret = process.env.NEXT_PUBLIC_GA4_ID

export const sendGA4Event = async (eventName: 'click_accept' | 'click_reject' | 'click_settings') => {
  if (hasWindow() && measurementId && apiSecret) {
    fetch(`https://www.google-analytics.com/mp/collect?measurement_id=${measurementId}&api_secret=${apiSecret}`, {
      method: 'POST',
      body: JSON.stringify({
        client_id: genUUID(window.crypto),
        events: [
          {
            name: `{{${eventName}}}`,
          },
        ],
      }),
    })
  }
}
